export default function ($newsForm, NewsVM) {
}
